import mixins from 'vue-typed-mixins';

import { User } from '@/interfaces/User';
import { eventBus } from '@/services/event-bus';

import user from '../user';

export const interactsUser = mixins().extend({
	data() {
		return {
			userState: null as null | User
		};
	},
	mounted() {
		user.userPromise?.then(user => {
			this.userState = user;
			this.onUserChange(user);
		});
		eventBus.$on('user-updated', this.userUpdated);
	},
	destroyed() {
		eventBus.$off('user-updated', this.userUpdated);
	},
	methods: {
		userUpdated(user: User) {
			this.userState = user;
			this.onUserChange(user);
		},
		updateUid(uid: string, newToken: string) {
			user.updateUser({ uid });
			user.refreshToken(newToken);
		},
		// Abstract method
		onUserChange(user: User) {
		}
	}
});
